// extracted by mini-css-extract-plugin
module.exports = {"container":"Import_container__MyFM2","tableWrapper":"Import_tableWrapper__3iWD6","table":"Import_table__StNY_","paragraph":"Import_paragraph__2luIC"};